export default {
  locale: 'zh-TW',
  language: '繁體中文',
  page: {
    title: 'tv.SOGA商城',
    error: {
      title: '對不起，出錯了！'
    },
    home: {
      title: '首頁',
      description: 'tvSOGA推出會員專屬商城『搜咖購物』，將會提供給會員們物美價廉的各式商品，甜甜價只有會員獨享，立即加入tvSOGA這個大家族，享受購物樂趣!!',
      keywords: 'tv.SOGA商城,搜咖購物'
    },
    reg: {
      title: '會員註冊',
      pwd: '設定密碼：',
      pwd_confirm: '確認密碼：',
      mobile_code: '短信驗證碼：',
      btn_reg: '註冊',
      btn_login: '會員登入',
      ph_pwd: '6-15位字母或數字',
      ph_pwd_confirm: '再次輸入設定密碼',
      diff_pwd: '兩次密碼輸入不一致！',

      verify_code: '輸入校驗碼',
      invalid_code: '校驗碼不正確！',
      btn_code: '獲取驗證碼',
      invalid_sms: '短信驗證碼不正確！',

      label_agree: '已閱讀並同意',
      label_privacy: '隱私權保護宣告',
      tip_privacy: '需要同意隱私權保護宣告！',
      btn_agree: '同意',
      btn_disagree: '不同意',

      alert_reg: '為維護您的權益，會員註冊將會立即開通tv.SOGA電視專屬瀏覽器的5天試用期。',
      btn_continue: '繼續註冊',
      btn_othertime: '稍後註冊',
      tip_reg: '加入會員立即開通tv.SOGA電視專屬瀏覽器5天試用！',
      register_ok: '歡迎您加入tv.SOGA！',
      register_fail: '註冊失敗！'
    },
    login: {
      title: '會員登入',
      forgot: '忘記密碼?',
      state_code: '國際區號：',
      mobile: '手機號碼：',
      pwd: '密  碼',
      btn_login: '登入',
      btn_reg: '註冊成為會員',
      ph_statecode: '請選擇區號',
      ph_mobile: '請填寫手機號碼',
      ph_pwd: '請輸入密碼',
      tip_invalid_pwd: '密碼無效！',

      quick_opt: '操作過於頻繁！',
      login_ok: '歡迎您再次回來！',
      login_fail: '登入失敗！'
    },
    resetpwd: {
      title: '重置密碼',
      btn_reset: '重置密碼',
      btn_login: '會員登入',

      reset_ok: '密碼重置成功！'
    },
    member: {
      title: '會員專區',
      mobile: '手機號碼：',
      nick: '暱稱：',
      sex: '性別：',
      sex_male: '男',
      sex_female: '女',

      location: '位置：',
      btn_location: '更改地區',
      loading_location: '正在獲取...',

      birth: '生日：',

      btn_pwd: '修改密碼',
      old_pwd: '舊密碼：',
      new_pwd: '新密碼：',
      cfm_pwd: '確認密碼：',
      ph_old_pwd: '請輸入舊密碼',
      ph_new_pwd: '6-15位字母或數字',
      ph_cfm_pwd: '再次輸入設定密碼',
      diff_pwd: '兩次密碼輸入不一致！',
      invalid_pwd: '新密碼無效！',

      ph_unset: '未設定',
      btn_birth: '請選擇',
      btn_sn_add: '添加序號',
      btn_sn_view: '查看所有序號/共{n}組',
      btn_sn_buy: '序號購買',

      label_device: '設備：',
      no_device: '未知',
      label_bind_time: '綁定時間：',
      label_expires: '過期時間：',
      label_no_bind: '尚未綁定！',

      tip_modify_ok: '修改成功！',
      btn_modify: '保存修改'
    },
    jump: {
      title: '跳轉',
      tip: '您將在{sec}秒後跳轉至',
      wait: '請耐心等候...',
      no_jump: '若無自動跳轉，請點擊',
      to_official: '若想瞭解tv.SOGA，請至',
      index: '首頁',
      official: '官方網站'
    },
    addr: {
      title: '地址管理',
      no_address: '還沒有收貨地址，趕緊去添加吧！',
      btn_new: '新建收貨地址'
    },
    goods_group: {
      title: '商品分类',
      label_search: '搜索：'
    },
    goods_detail: {
      title: '商品詳情',
      label_des: '產品介紹',
      label_delivery: '運送方式',
      label_notice: '注意事項',
      label_refund: '退換貨規定'
    },
    cart: {
      title: '購物車',
      tip_no_items: '購物車空空如也，快去添加商品吧！'
    },
    order_manage: {
      title: '訂單管理',
      no_order: '尚無訂單',
      label_status: '狀態：',
      all_status: '全部',
      label_sort: '排序：',
      sort_values: [
        '日期新到舊',
        '日期舊到新',
        '金額多到少',
        '金額少到多'
      ]
    },
    order_add: {
      title: '商品訂購',

      buy_num: '購買數量',
      bind_type: '綁定方式',
      bind_no: '序號不綁定任何帳戶',
      bind_yes: '序號綁定當前帳戶',

      btn_order_add: '提交訂單',

      title_addr: '請選擇收貨地址',
      tip_invalid_addr: '請填寫配送地址',

      tip_pay_confirm: '請確認收件資料填寫正確，後續寄件將以填寫資料為主。',
      btn_pay_confirm: '確認購買',
      use_discount: '使用折扣碼',
      discount_code: '折扣碼',
      discount_amount: '折扣金額',
      not_use_discount: '不使用',
      use_coin: '碳幣抵扣',
      max_use_coin: '最多可使用<span>{n}</span>個碳幣',
      use: '使用',
      no_use: '不使用',
      input_coin_tip: '請選擇要抵扣的碳幣數量'
    },
    order_pay: {
      title: '訂單支付',
      label_pay_amount: '合計支付'
    },
    order_detail: {
      title: '訂單詳情',
      btn_rebuy: '再次購買',
      btn_refund: '退貨申請',
      btn_complete: '完成訂單',

      label_remark: '備注',
      btn_remark: '發送',
      service_name: 'tvSoga小精靈'
    },
    order_refund: {
      title: '退貨申請',
      refund_info: '退貨資料填寫',
      btn_request: '申請',
      ph_select: '請選擇',
      ph_input: '請輸入',

      ph_bank_user: '銀行戶名',
      ph_bank_code: '銀行代碼',
      ph_bank_name: '銀行名稱',
      ph_bank_account: '銀行帳號',

      title_addr: '退貨地址編輯',

      jump_msg: '已收到您的退貨申請'
    }
  },
  menu: {
    tip_login: '請登入！',

    group_title_note: '購物說明',
    item_label_about: '關於我們',
    item_label_notice: '購物須知',
    item_label_qa: '常見問題',
    item_label_privacy: '隱私權保護宣告',

    btn_official: '官方',

    order_query: '訂單查詢',
    member_area: '會員專區',
    member_addr: '收貨地址',
    register_login: '會員登入/註冊',
    logout: '登出',
    delete_account: '刪除帳號',

    tip_logout: '已登出！'
  },
  user: {
    btn_login: '會員登錄',
    del_tip_title: '警告：刪除使用者資料操作不可逆！請謹慎操作！',
    del_tip_logout: '請先登入使用者再進行刪除操作！',
    del_tip_content_1: '<p style="font-size: 1.2rem;">您正在刪除使用者 [<span style="color:blue">{username}</span>] 的所有資料。</p>',
    del_tip_content:
      [
        '刪除使用者資料後，該使用者的所有資訊將被永久刪除，包括訂單、收貨地址、個人資料等。',
        '是否確認刪除使用者資料？'
      ],
    btn_del: '確認刪除',
    btn_cancel: '取消操作',
    del_ok: '帳號刪除成功！',
    del_ok_content: '該使用者的所有資訊將被永久刪除，包括訂單、收貨地址、個人資料等。',
    del_fail: '刪除失敗！',
    del_fail_content: '刪除使用者資料失敗，請稍後再試。',
    del_confirm: '請輸入登入密碼以授權刪除使用者資料！'
  },
  goods: {
    group_all: '全部商品',
    group: '商品分類',
    tip_no_items: '沒有任何商品！',
    tip_no_exist: '商品不存在或已經下架！',
    name: '商品名',
    price: '單價',
    tip_sellout: '缺貨',
    tip_not_enough: '庫存不足！',
    alert_not_enough: '{name} 庫存不足！',
    label_stock: '庫存',
    discount: '{n}折',

    ph_qrcode: '正在生成二維碼！',
    tip_qrcode_fail: '二維碼獲取錯誤！',

    label_original: '原價',
    label_promotion: '活動價'
  },
  order: {
    status: {
      0: '錯誤訂單',
      1: '等待買家付款',
      2: '買家已付款',
      3: '賣家已出貨',
      4: '買家已簽收',
      5: '已評價',
      10: '交易完成',
      97: '支付確認中',
      98: '付款失敗',
      99: '交易失敗'
    },
    err_status: '狀態異常',
    no_order: '訂單不存在',

    order_no: '訂單編號：',
    buy_num: '數量',

    total_amount: '訂單小計',
    promotion_amount: '優惠金額',
    discount_amount: '折扣金額',
    pay_amount: '訂單金額',
    freight_amount: '運費金額',
    freight_discount: '運費折扣',

    weight: '重量',

    receive_info: '收件人資料',
    label_receive_name: '聯絡人：',
    label_receive_tel: '聯絡電話：',
    label_transport_way: '寄送方式：',
    label_receive_addr: '寄送地址：',
    label_delivery_no: '寄件編號：',

    transport_way: '配送方式',
    way_logistics: '物流配送',
    transport_addr: '配送地址',

    transport_info: '配送信息',
    area_not_support: '所在地區不支持！',

    startup_sn: '啓動序號',
    bind_sn: '綁定用戶：',
    label_time: '訂單時間',
    add_time: '下單時間',
    pay_time: '付款時間',
    complete_time: '交易成功時間',

    refund_info: '退貨信息',
    label_refund_reason: '退貨原因',
    label_refund_user: '訂購人姓名：',
    label_refund_addr: '退貨收件地址：',
    label_refund_tel: '聯繫電話：',
    label_refund_account: '退款銀行帳號',

    refund_refuse_reason: '婉拒退貨原因',

    refund_time: '退貨時間',
    label_refund_time_request: '申請時間：',
    label_refund_time_accept: '接收退貨時間：',
    label_refund_time_refuse: '拒絕退貨時間：',

    label_complete_order: '※收到商品後請點選「完成訂單」，若未點選，系統於7天後自動完成訂單，若未收到商品，請與我們聯繫。'
  },
  footer_info_html: '客服信箱：tvsoga@gmail.com<br>' +
    '服務時間：週一至週五 09:00AM-06:00PM<br>' +
    '（午休時間：12:30PM-01:30PM）<br>' +
    '（公休日：週六與週日）',
  addr: {
    title: '收貨地址編輯',
    title_new: '新建收貨地址',
    label_user: '聯絡人：',
    ph_user: '聯絡人姓名',
    label_tel: '手機號碼：',
    ph_tel: '通過此號碼聯繫',
    label_area: '所在地區：',
    ph_area_sel: '請選擇...',

    title_area: '請選擇所在區域',
    ph_area_first: '國家或地區',

    label_address: '詳細地址：',
    ph_address: '請輸入地址',
    label_addr_def: '設置預設地址',
    value_def: '預設',

    tip_invalid_name: '請填寫聯繫人！',
    tip_invalid_tel: '手機號碼不正確！',
    tip_invalid_state_code: '手機區號不正確！',
    tip_invalid_area: '請選擇收貨區域！',
    tip_invalid_addr: '請填寫詳細地址！',
    postcode: '郵遞區號'
  },
  invoice: {
    title: '發票資訊',
    personal_invoice: '個人發票',
    company_invoice: '公司發票',
    tax_id: '統一編號',
    invoice_head: '發票抬頭',
    tax_id_tip: '請輸入發票編碼',
    invoice_head_tip: '請輸入發票抬頭',
    personal_tip: '<p>信用卡結帳（台灣用戶）：</p>\n' +
      ' <p>發票會開立於銀行端留存之台灣手機門號的簡訊內。</p>\n' +
      ' <p></p>\n' +
      ' <p>信用卡結帳（海外用戶及ATM結帳用戶）：</p>\n' +
      ' <p>將開立二聯式發票，如需索取正本請自行負擔運費。</p>',
    invoice_tip: '※依統一發票使用辦法規定：個人發票一經開立，無法更改或改開公司戶發票，需開立統編請選擇『公司發票』，一經開立不得要求更改。',
    invoice_tip2: '※依統一發票使用辦法規定：公司戶發票一經開立，無法更改為個人發票。請務必確認輸入之公司統編是否正確，一經開立不得要求更改。',
    history_invoice: '歷史開票資訊',
    add_invoice: '新增開票資訊',
    tax_id_tip2: '統一編號不正確'
  },
  common: {
    alert_title: '溫馨提示',
    logining: '正在登入...',
    delete_confirm: '確定刪除？',
    btn_ok: '確定',
    btn_cancel: '取消',
    btn_back: '返回',
    btn_save: '保存',
    btn_del: '刪除',
    btn_next: '下一步',

    btn_buy: '立即購買',
    btn_pay: '支付',

    tip_loading: '正在加載...',
    tip_refresh: '刷新中...',
    tip_loadmore: '加載中...',

    err_param: '參數錯誤',
    err_server: '若您持續遇到此問題，請聯絡<a href="https://lin.ee/sFVGdO6" target="_blank">Line@客服</a>支援以獲得協助。<br/>\n'
  },
  error: {
    400: '請求錯誤',
    401: '未授權，請登錄',
    403: '拒絕訪問',
    404: '請求錯誤',
    408: '請求超時',
    500: '服務器內部錯誤',
    501: '服務器內部錯誤',
    502: '網關錯誤',
    503: '服務不可用',
    504: '網關超時',
    505: 'HTTP版本不受支持',

    1000000: '獲取數據失敗！',
    1010000: '未登錄！',
    1011000: '令牌失效！',
    1012000: '無權訪問！',

    // 1020000: '參數錯誤！',
    1020003: '密碼格式不正確！',
    1020004: '帳號未註冊！',
    1020005: '密碼錯誤！',

    1020014: '驗證碼錯誤！',
    1020015: '郵箱地址錯誤！',
    1020022: 'SN碼錯誤！',
    1020023: 'SN已經被使用！',
    1020024: '沒有綁定SN！',
    1020025: '授權過期！',

    1021000: '文件上傳錯誤！',
    1021002: '文件不存在！',

    // 1100000: '服務器異常，請重試！',
    1100001: '操作超時！',

    1200000: '服務器維護中！'
  }
}
